"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default;

var _utils = require("../utils"),
    icon = "video";

function _default() {
  return function (a) {
    var b = a.billingEntityCode,
        c = a.addonsCosts,
        d = a.includedAddons,
        e = (0, _utils.getCostForAddon)({
      costs: d.includes("VIDEO_OUTPUT") ? null : c.VIDEO_OUTPUT.costs,
      billingEntityCode: b
    });
    return [{
      reviewLabel: "Additional Output",
      label: "Additional Output",
      value: "ADDITIONAL_OUTPUT",
      icon: icon,
      cost: e
    }];
  };
}